import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where, orderBy, Timestamp } from 'firebase/firestore';
import { db, auth } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import './StatusPermintaan.css'; // Import the CSS file

// Helper to format Firestore Timestamp to readable date string
const formatDate = (timestamp) => {
  if (timestamp instanceof Timestamp) {
    return timestamp.toDate().toLocaleDateString('id-ID');
  }
  return typeof timestamp === 'string' ? timestamp : 'N/A';
};

const StatusPermintaan = () => {
  const [alatRequests, setAlatRequests] = useState([]);
  const [bahanRequests, setBahanRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [currentUser, setCurrentUser] = useState(null);

  // Get current user
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      if (user) {
        // Fetch requests once user is confirmed
        fetchRequests(user.uid);
      } else {
        // Clear requests if user logs out
        setAlatRequests([]);
        setBahanRequests([]);
        setError('Silakan login untuk melihat status permintaan Anda.');
      }
    });
    return () => unsubscribe();
  }, []);

  // Fetch requests for the current user
  const fetchRequests = async (userId) => {
    if (!userId) return;

    setLoading(true);
    setError('');
    try {
      // Fetch Alat Requests
      const alatRef = collection(db, 'permintaan_alat');
      const qAlat = query(
        alatRef,
        where('userId', '==', userId),
        orderBy('tanggalPermintaan', 'desc') // Show newest first
      );
      const alatSnapshot = await getDocs(qAlat);
      const alatData = alatSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setAlatRequests(alatData);

      // Fetch Bahan Requests
      const bahanRef = collection(db, 'permintaan_bahan');
      const qBahan = query(
        bahanRef,
        where('userId', '==', userId),
        orderBy('tanggalPermintaan', 'desc') // Show newest first
      );
      const bahanSnapshot = await getDocs(qBahan);
      const bahanData = bahanSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setBahanRequests(bahanData);

    } catch (err) {
      console.error("Error fetching requests:", err);
      setError('Gagal memuat status permintaan.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="status-permintaan-container">
      <h2>Status Permintaan Saya</h2>

      {error && <div className="error-message">{error}</div>}

      {loading && <div className="loading-message">Memuat data...</div>}

      {!loading && !currentUser && <div className="error-message">Silakan login untuk melihat status permintaan Anda.</div>}

      {currentUser && (
        <>
          {/* Alat Requests Table */}
          <h3>Permintaan Alat</h3>
          <div className="status-permintaan-table-container">
            <table className="status-permintaan-table">
              <thead>
                <tr>
                  <th>Nama Alat</th>
                  <th>Jumlah</th>
                  <th>Tgl Pinjam</th>
                  <th>Tgl Kembali</th>
                  <th>Tgl Permintaan</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {alatRequests.map((req) => (
                  <tr key={req.id}>
                    <td>{req.namaAlat || 'N/A'}</td>
                    <td>{req.jumlah || 'N/A'}</td>
                    <td>{formatDate(req.tanggalPinjam)}</td>
                    <td>{formatDate(req.tanggalKembali)}</td>
                    <td>{formatDate(req.tanggalPermintaan)}</td>
                    <td>
                      <span className={`status-badge status-${req.status || 'unknown'}`}>
                        {/* Capitalize status for better display */}
                        {req.status ? req.status.charAt(0).toUpperCase() + req.status.slice(1) : 'Unknown'}
                      </span>
                    </td>
                  </tr>
                ))}
                {alatRequests.length === 0 && !loading && (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center' }}>Belum ada permintaan alat.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Bahan Requests Table */}
          <h3>Permintaan Bahan</h3>
          <div className="status-permintaan-table-container">
            <table className="status-permintaan-table">
              <thead>
                <tr>
                  <th>Nama Bahan</th>
                  <th>Jumlah Diminta</th>
                  <th>Satuan</th>
                  <th>Tgl Permintaan</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {bahanRequests.map((req) => (
                  <tr key={req.id}>
                    <td>{req.namaBahan || 'N/A'}</td>
                    <td>{req.jumlahDiminta || 'N/A'}</td>
                    <td>{req.satuan || 'N/A'}</td>
                    <td>{formatDate(req.tanggalPermintaan)}</td>
                    <td>
                      <span className={`status-badge status-${req.status || 'unknown'}`}>
                        {/* Capitalize status for better display */}
                        {req.status ? req.status.charAt(0).toUpperCase() + req.status.slice(1) : 'Unknown'}
                      </span>
                    </td>
                  </tr>
                ))}
                {bahanRequests.length === 0 && !loading && (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center' }}>Belum ada permintaan bahan.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default StatusPermintaan;
